import FetchPromise from '~/agent/fetch-promise';

export const createAcademyAISearchAnswer = (question: string) =>
  FetchPromise.post('learner_search_answers', { question });
